export function formatPrice(price) {
  // Remove non-numeric characters except for the decimal point
  const sanitizedPrice = typeof price === 'string' 
    ? price.replace(/[^\d.]/g, '') 
    : price;
    
  const numericPrice = Number(sanitizedPrice);

  if (isNaN(numericPrice)) return "0.0";

  const priceInMillions = numericPrice / 1000000;

  const formattedPrice = priceInMillions.toFixed(1);

  return formattedPrice;
}
